import { render, staticRenderFns } from "./remark.vue?vue&type=template&id=a1cf7580&scoped=true&"
import script from "./remark.vue?vue&type=script&lang=js&"
export * from "./remark.vue?vue&type=script&lang=js&"
import style0 from "./remark.vue?vue&type=style&index=0&id=a1cf7580&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1cf7580",
  null
  
)

export default component.exports